import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import axios from 'axios';
import Client from './client';
import { CaseUtil, getUrlParams } from '../utilities/common';
var client = new Client();
export var getQuest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(hashId, questId, sign) {
    var customs,
      url,
      urlParams,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            customs = _args.length > 3 && _args[3] !== undefined ? _args[3] : '';
            if (!window.isLocal) {
              _context.next = 7;
              break;
            }
            urlParams = getUrlParams();
            url = "//".concat(location.host, "/survey/api/v1/questionnaire/preview/").concat(urlParams.id, "/");
            return _context.abrupt("return", axios.get(url).then(function (res) {
              if (res.data.code == 401) {
                window.location.href = "//".concat(location.host, "/survey/auth/login?next=").concat(encodeURIComponent(window.location.href));
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve();
                  }, 2000);
                });
              }
              return res.data;
            }).catch(function (err) {
              var _err$response;
              if ((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 403) {
                return 'noPreviewAuth';
              }
            }));
          case 7:
            if (sign) {
              url = "/v2/q/".concat(questId, "/").concat(hashId, "/").concat(sign, "/?").concat(customs);
            } else {
              url = "/v1/q/".concat(hashId, "/");
            }
          case 8:
            return _context.abrupt("return", client.get(url, null));
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return function getQuest(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var submitQuest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(hashId, params, questId, sign, hideAnalysisHeader, option) {
    var url, formData, answers, extra;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (sign) {
              url = "/v2/q/".concat(questId, "/").concat(hashId, "/").concat(sign, "/");
            } else {
              url = "/v1/q/".concat(hashId, "/");
            }
            formData = new FormData();
            answers = CaseUtil.toSnake(params);
            formData.append('answers', JSON.stringify(answers));
            if (hideAnalysisHeader) {
              extra = {
                hide_analysis_header: hideAnalysisHeader
              };
              formData.append('extra', JSON.stringify(extra));
            }
            return _context2.abrupt("return", client.post(url, formData, option));
          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return function submitQuest(_x4, _x5, _x6, _x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();
export var getLocationMap = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var country,
      previewUrl,
      hostUrl,
      url,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            country = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 'cn';
            previewUrl = "//".concat(location.host, "/survey/api/v1/questionnaires/country_detail/?country=").concat(country.toLowerCase());
            hostUrl = "//".concat(location.host, "/open_api/v1/api/country_detail/?country=").concat(country.toLowerCase());
            url = location.pathname.includes('preview') ? previewUrl : hostUrl;
            return _context3.abrupt("return", axios.get(url).then(function (res) {
              return res.data;
            }));
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return function getLocationMap() {
    return _ref3.apply(this, arguments);
  };
}();
export var lotteryDraw = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    var url;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = "/v1/api/lottery_draw/";
            return _context4.abrupt("return", client.post(url, params, {}));
          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));
  return function lotteryDraw(_x10) {
    return _ref4.apply(this, arguments);
  };
}();
export var loadLatestLotteryInfo = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var url;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = "/v1/api/lottery_draw/";
            return _context5.abrupt("return", client.get(url, params, {}));
          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));
  return function loadLatestLotteryInfo(_x11) {
    return _ref5.apply(this, arguments);
  };
}();
export var lotteryUserInfo = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    var url;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = "/v1/api/update_contact/";
            return _context6.abrupt("return", client.post(url, params, {}));
          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));
  return function lotteryUserInfo(_x12) {
    return _ref6.apply(this, arguments);
  };
}();